import { useLocale } from '../../../context/NbLocalizationContext';
import { getMobileAppLink } from '../../utils/mobileAppLink';
import { NbButton } from '../button/Button';
import classes from './MobileAppBanner.module.scss';
import { MobileAppBannerContent } from './MobileAppBannerContent';

type MobileAppBannerProps = {
  onDismiss: () => void;
};

export const MobileAppBanner = ({ onDismiss }: MobileAppBannerProps) => {
  const { translation } = useLocale();

  return (
    <div className={classes.overlay}>
      <div className={classes.banner}>
        <MobileAppBannerContent onDismiss={onDismiss} />
        <div className={classes.actions}>
          <NbButton
            className={classes.openAppButton}
            variant="contained"
            color="primary"
            href={getMobileAppLink()}
          >
            {translation.mobileAppBanner.openApp}
          </NbButton>
          <NbButton
            className={classes.stayInBrowserButton}
            variant="text"
            color="primary"
            onClick={onDismiss}
          >
            {translation.mobileAppBanner.stayInBrowser}
          </NbButton>
        </div>
      </div>
    </div>
  );
};
